// Conditional logger — only logs in development, silent in production
const isDev = process.env.NODE_ENV === 'development';

const logger = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  log: (...args) => { if (isDev) console.log(...args); },
};

export default logger;
